import {
  radioUI,
  radioSchema,
  textUI,
  titleUI,
  currentOrPastDateRangeUI,
  currentOrPastDateSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { remarriageEndOptions } from '../../../utils/labels';
import { customTextSchema } from '../../definitions';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['household-remarriage-details-title']),
    remarriageEndCause: radioUI({
      title: content['household-remarriage-details-end-cause'],
      labels: remarriageEndOptions,
      required: formData => formData?.stillRemarried === false,
      hideIf: formData => formData?.stillRemarried === true,
    }),
    endCauseExplanation: textUI({
      title: content['household-remarriage-details-end-explanation'],
      required: formData => formData?.remarriageEndCause === 'other',
      errorMessages: {
        required: content['household-remarriage-details-end-explanation-error'],
      },
      maxLength: 256,
      expandUnder: 'remarriageEndCause',
      expandUnderCondition: 'other',
      'ui:options': {
        hideIf: formData => formData?.stillRemarried === true,
      },
    }),
    remarriageDates: currentOrPastDateRangeUI(
      {
        title: content['household-remarriage-details-dates-start'],
        monthSelect: false,
      },
      {
        title: content['household-remarriage-details-dates-end'],
        removeDateHint: true,
        monthSelect: false,
        hideIf: formData => formData?.stillRemarried === true,
        required: formData => formData?.stillRemarried === false,
      },
      content['date-error'],
    ),
  },
  schema: {
    type: 'object',
    required: ['remarriageDates'],
    properties: {
      remarriageEndCause: radioSchema(Object.keys(remarriageEndOptions)),
      endCauseExplanation: customTextSchema,
      remarriageDates: {
        type: 'object',
        required: ['from'],
        properties: {
          from: currentOrPastDateSchema,
          to: currentOrPastDateSchema,
        },
      },
    },
  },
};
